/**
 * Костыль нужен из за кэширования
 * Обработка переходов с поисковиков
 */
(function ($) {
    $(document).ready(function () {
        var ref = document.referrer;

        if (App.queryString.hasOwnProperty('recl')) {
            return;
        }

        if (ref) {
            var channelAdvert = null;

            if (ref.indexOf('yandex') != -1) {
                channelAdvert = 84541;
            }

            if (ref.indexOf('google') != -1) {
                channelAdvert = 84542;
            }

            if (ref.indexOf('bing') != -1) {
                channelAdvert = 84559;
            }

            if (ref.indexOf('go.mail') != -1) {
                channelAdvert = 84544;
            }

            if (ref.indexOf('rambler') != -1) {
                channelAdvert = 84543;
            }

            if (channelAdvert !== null) {
                App.cookie.set(App.constants.advert.CookieNameChannel,
                    channelAdvert,
                    {expires: App.constants.advert.CookieExpire});
            }
        }
    });
})(jQuery);
